module.exports = __webpack_public_path__ + "static/media/Mapa-Acre.66f4d8b4.svg";